import React, { FC, useContext, useState } from 'react';
// Images
import DownloadInquiriesArrow from 'Assets/ui/downloadInquriesArrow.svg';
// Context
import UserDetailsContext from 'Context/userDetailsContext';
// Components
import Dropdown from 'Components/Dropdown';
import withErrorBoundary from 'HOC/ErrorBoundary';
// Styles
import injectSheet from 'react-jss';
import stylesheet from './styles';

interface Props {
  classes?: any;
  locations: any;
  startDate: any;
  endDate: any;
}

const DownloadInquiries: FC<any> = (props: Props) => {
  const { classes, locations, startDate, endDate } = props;

  // get instId from context
  const userDetails = useContext(UserDetailsContext);
  const { instId } = userDetails;

  // selected loc_id for download inquries //
  const [selectedInquiryId, setSelectedInquiryId] = useState({
    label: 'All',
    value: 'all',
  });

  const downloadInquiries = () => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const allUrl = `${baseUrl}api/v2/export/organization/${instId}/leads.xls?startDate=${startDate}&endDate=${endDate}`;
    const idUrl = `${baseUrl}api/v2/export/experience/${selectedInquiryId.value}/leads.xls?startDate=${startDate}&endDate=${endDate}`;
    return selectedInquiryId.value === 'all' ? allUrl : idUrl;
  };

  const getLocations = () => {
    // filter out empty names //
    const updatedLocations = locations
      .filter((location) => location.name.length > 0)
      .map((location) => {
        return {
          label: location.name,
          value: location.loc_id,
        };
      });

    return [{ label: 'All', value: 'all' }, ...updatedLocations];
  };

  return (
    <div className={classes.downloadInquiries}>
      <div className={classes.downloadTitle}>Download Inquiries</div>
      <Dropdown
        colorOverRide={{
          open: {
            border: {
              color: 'rgb(204, 216, 226)',
            },
            text: {
              color: '#778491',
            },
          },
          close: {
            border: {
              color: 'rgb(204, 216, 226)',
            },
            text: {
              color: '#778491',
            },
          },
        }}
        width={`${170}px`}
        defaultValue={
          selectedInquiryId || {
            label: 'All',
            value: 'all',
          }
        }
        onChange={(e: any) => setSelectedInquiryId(e.target)}
        items={getLocations()}
      />
      <a
        href={downloadInquiries()}
        target="_blank"
        aria-label="Download"
        title="Download"
        className={classes.downloadInquiriesButton}
        rel="noreferrer"
      >
        <DownloadInquiriesArrow fill="#94A1AD" />
      </a>
    </div>
  );
};

DownloadInquiries.defaultProps = {
  classes: [],
};

export default withErrorBoundary(injectSheet(stylesheet)(DownloadInquiries));
